import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { URLRoutes } from '@/core/common/helpers';

const AsasqtPortal = () => {
  const router = useRouter();

  useEffect(() => {
    router.push({
      pathname: `/${URLRoutes.auth}`,
      query: router.query,
    });
  }, [router]);

  return <></>;
};
export default AsasqtPortal;
